export default {
  templates: [],
  loading: false,
};
